import { Api } from '../base/api';
export class ProductAPI extends Api {
    constructor(cdn, baseUrl, options) {
        super(baseUrl, options);
        this.cdn = cdn;
    }
    // загрузка всех продуктов
    async getProducts() {
        const data = (await this.get("/product" /* EnumProductAPIPaths.PATH_PRODUCTS */));
        // изначально в image идёт .svg, меняем на .png + добалвляем сслыку
        data.items.map((product) => (product.image = `${this.cdn}${product.image.replace(/\.svg$/, '.png')}`));
        return data.items;
    }
    // Загрузка продукта по id
    async getProduct(id) {
        const data = await this.get(`${"/product/" /* EnumProductAPIPaths.PATH_PRODUCT */}${id}`);
        return data;
    }
    // загрузка всех order на сервер
    async orderProducts(order) {
        const data = (await this.post("/order" /* EnumProductAPIPaths.PATH_ORDER */, order));
        return data;
    }
}
